import { Connection } from 'utils';
import { GET_TESTIMONIALS } from 'constants/api';

const getTestimonials = () => Connection.post(GET_TESTIMONIALS, []);

export default { getTestimonials };
